import { connect } from 'react-redux';

import type {
  ImageOptionDispatchProps,
  ImageOptionProps,
} from 'src/components/organisms/Personalisation/components/ImageOption/ImageOption';
import { ImageOption } from 'src/components/organisms/Personalisation/components/ImageOption/ImageOption';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectOutstandingPersonalisations,
  selectSelectedOption,
} from 'src/redux/personalisation/selectors';
import { actions as personalisationActions } from 'src/redux/personalisation/slice';
import { selectProduct } from 'src/redux/product/selectors';

type OwnProps = Pick<ImageOptionProps, 'displayValidation' | 'forwardedRef' | 'option'>;

/** Redux selection and min/max (`imageOptionBounds(ownProps.option)`) are scoped per catalogue `option.id`. */
const mapStateToProps = (state: ReduxApplicationState, ownProps: OwnProps) => ({
  error:
    Boolean(ownProps.displayValidation) &&
    selectOutstandingPersonalisations(state).some((opt) => opt.id === ownProps.option.id),
  productCode: selectProduct(state).code,
  selectedValues: selectSelectedOption(state, ownProps.option.id),
});

const mapDispatchToProps: ImageOptionDispatchProps = {
  selectPersonalisation: personalisationActions.selectPersonalisation,
  trackImageUploadAttempt: personalisationActions.trackImageUploadAttempt,
  trackImageUploadError: personalisationActions.trackImageUploadError,
  trackRequiredImageOptionImpression: personalisationActions.trackRequiredImageOptionImpression,
};

export const ImageOptionContainer = connect(mapStateToProps, mapDispatchToProps)(ImageOption);
